import React, { useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { MdMenu } from "react-icons/md"; // Import necessary icons
import logo from "../img/Caritas Matha Logo 1.png"; // Adjust path as necessary
import "../styles/navbar.css";
import { IoIosArrowDown } from "react-icons/io";
import navigationItems from "../constants/navConfig";
import deparmentsImg from "../components/img/nav-deparments.png";
import servicesImg from "../components/img/nav-services.png";
import resourcesImg from "../components/img/nav-resources.png";
import aboutImg from "../components/img/nav-about.png";
import hospitalA from "../components/img/nav-hospitalA.png";
import hospitalB from "../components/img/nav-hospitalB.png";
import hospitalC from "../components/img/nav-hospitalC.png";
import hospitalD from "../components/img/nav-hospitalD.png";
function Navbar() {
  const [navMenu, setNavMenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navHandler = (id) => {
    setNavMenu(navigationItems[id]);
  };
  const mobNavHandler = (id) => {
    setNavMenu((prevState) => {
      if (prevState == null || prevState !== navigationItems[id])
        return navigationItems[id];
      else return null;
    });
  };
  const imgArr = [deparmentsImg, "", "", servicesImg, resourcesImg, aboutImg];
  const hospitalArr = [
    {
      name: "Caritas Hospital",
      address: "Caritas Hospital, Thellakom P.O, Kottayam - 686630",
      img: hospitalA,
      phn: "0481-2790025 to 29",
      link: "https://caritashospital.org/",
    },
    {
      name: "Caritas Family Hospital",
      address:
        "Karipal Building, Vadavathoor P.O,Kalathipady, Kottayam - 686018",
      img: hospitalB,
      phn: "0481 2570100",
      link: "https://www.caritasfamilyhospital.com/",
    },
    {
      name: "Caritas KMM Hospital",
      address: "Kurishupally kavala, Puthenangady, Kottayam, Kerala 686001",
      img: hospitalC,
      phn: "0481 2580047",
      link: "https://caritashospital.org/caritaskkm/",
    },
    {
      name: "Caritas HDP Hospital",
      address: "Caritas HDP Hospital, Kaipuzha, Kottayam, Kerala - 686602",
      img: hospitalD,
      phn: "0481 2711418",
      link: "https://caritashospital.org/caritas-hdp-hospital/",
    },
  ];
  const toggleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="App-navbar">
      <div className="Navbar-top">
        <div className="Navbar-right">
          <a href="https://www.caritashospital.org/career/" className="Navbar-link">
            Careers
          </a>
          <span className="Navbar-separator">|</span>
          <a href="tel:+919496555200" className="Navbar-number">
            24x7 Emergency: +91 (0) 9496555200
          </a>
        </div>
      </div>
      <div className="Navbar-bottom">
        <div className="Navbar-left">
          <a href="/">
            <img src={logo} alt="Logo" className="Navbar-logo" />
          </a>
        </div>
        <div className="Navbar-center">
          <ul className="Navbar-links">
            <li
              className={`Navbar-item ${
                navMenu ? (navMenu.id == 0 ? "active" : "") : ""
              }`}
              onMouseEnter={() => navHandler(0)}
            >
              <span>
                Departments <IoIosArrowDown />
              </span>
            </li>
            <li
              className={`Navbar-item ${
                navMenu ? (navMenu.id == 1 ? "active" : "") : ""
              }`}
              onMouseEnter={() => navHandler(1)}
            >
              <a className="doctor-navbar" href='/doctors'>Doctors </a>
            </li>
            <li
              className={`Navbar-item ${
                navMenu ? (navMenu.id == 2 ? "active" : "") : ""
              }`}
              onMouseEnter={() => navHandler(2)}
            >
              <span>
                Our Hospitals <IoIosArrowDown />
              </span>
            </li>
            <li
              className={`Navbar-item ${
                navMenu ? (navMenu.id == 3 ? "active" : "") : ""
              }`}
              onMouseEnter={() => navHandler(3)}
            >
              <span>
                Services <IoIosArrowDown />
              </span>
            </li>
            <li
              className={`Navbar-item ${
                navMenu ? (navMenu.id == 4 ? "active" : "") : ""
              }`}
              onMouseEnter={() => navHandler(4)}
            >
              <span>
                Resources <IoIosArrowDown />
              </span>
            </li>
            <li
              className={`Navbar-item ${
                navMenu ? (navMenu.id == 5 ? "active" : "") : ""
              }`}
              onMouseEnter={() => navHandler(5)}
            >
              <span>
                About <IoIosArrowDown />
              </span>
            </li>
            {/* navbar dropdown content  - Desktop*/}
            {!!navMenu && !!navMenu.subLinks && (
              <div className="nav-content">
                {!!navMenu && navMenu.id == 2 && (
                  <div className="hospital-section">
                    {hospitalArr.map((hospital) => (
                      <div className="hospital-card">
                        <img src={hospital.img}></img>
                        <h3>{hospital.name}</h3>
                        <p>{hospital.address}</p>
                        <div className="hospital-btm">
                          <h3>{hospital.phn}</h3>
                          <a href={hospital.link}>
                            know more <FaChevronRight />
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {!!navMenu && !!navMenu.img && (
                  <section>
                    <div>
                      <img src={imgArr[navMenu.id]}></img>
                      {navMenu.imgTitle && <h1>{navMenu.imgTitle}</h1>}
                    </div>
                  </section>
                )}
                {!!navMenu && !!navMenu.subLinks && (
                  <>
                    {!!navMenu.subLinks[0] && (
                      <>
                        {sectiondivider()}
                        <section className="first-section">
                          <h2>{navMenu.subLinks[0].title}</h2>
                          <ul>
                            {navMenu.subLinks[0].subTitle.map((link, i) => (
                              <li key={i}>
                                <a href={link.link}>{link.name}</a>
                              </li>
                            ))}
                          </ul>
                        </section>
                      </>
                    )}
                    {!!navMenu.subLinks[1] && (
                      <>
                        {sectiondivider()}
                        <section>
                          <h2>{navMenu.subLinks[1].title}</h2>
                          {navMenu.subLinks[1].subTitle.map((link) => (
                            <li>
                              <a href={link.link}>{link.name}</a>
                            </li>
                          ))}
                        </section>
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </ul>
          <button className="appointment-button">
            <a href="/appointment" className="Navbar-appointments">
              Appointments
            </a>
          </button>
          {/* menu hamburger icon -mobile,tablet */}
          <button
            className="menu-icon"
            aria-label="Menu"
            aria-controls="navigation"
            onClick={() => toggleMenuOpen()}
          >
            <MdMenu />
          </button>

          {/* menu side-bar -Mobile,tablet */}
          <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
            <ul className="mob-navbar-links">
              <li
                className={`Navbar-item ${
                  navMenu ? (navMenu.id == 0 ? "active" : "") : ""
                }`}
                onClick={() => mobNavHandler(0)}
              >
                <span className="links">
                  Departments <IoIosArrowDown />
                </span>
                <div className="mob-nav-content">
                  {!!navMenu && !!navMenu.subLinks && (
                    <>
                      {!!navMenu.subLinks[0] && (
                        <>
                          <section className="first-section">
                            <h2>{navMenu.subLinks[0].title}</h2>
                            <ul>
                              {navMenu.subLinks[0].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </>
                      )}
                    </>
                  )}
                </div>
              </li>
              <li
                className={`Navbar-item ${
                  navMenu ? (navMenu.id == 1 ? "active" : "") : ""
                }`}
                onClick={() => mobNavHandler(1)}
              >
                <a className="links" href="/doctors">Doctors</a>
              </li>
              <li
                className={`Navbar-item ${
                  navMenu ? (navMenu.id == 2 ? "active" : "") : ""
                }`}
                onClick={() => mobNavHandler(2)}
              >
                <span className="links">
                  Our Hospital <IoIosArrowDown />
                </span>
                <div className="mob-nav-content">
                  {!!navMenu && navMenu.id == 2 && (
                    <div className="hospital-section">
                      {hospitalArr.map((hospital) => (
                        <div className="hospital-card">
                          <h3><a href={hospital.link}>{hospital.name}</a></h3>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </li>
              <li
                className={`Navbar-item ${
                  navMenu ? (navMenu.id == 3 ? "active" : "") : ""
                }`}
                onClick={() => mobNavHandler(3)}
              >
                <span className="links">
                  Services <IoIosArrowDown />
                </span>
                <div className="mob-nav-content">
                  {!!navMenu && !!navMenu.subLinks && (
                    <>
                      {!!navMenu.subLinks[0] && (
                        <>
                          <section className="first-section">
                            <h2>{navMenu.subLinks[0].title}</h2>
                            <ul>
                              {navMenu.subLinks[0].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </>
                      )}
                      {!!navMenu.subLinks[1] && (
                        <div>
                          {sectiondivider()}
                          <section className="second-section">
                            <h2>{navMenu.subLinks[1].title}</h2>
                            <ul>
                              {navMenu.subLinks[1].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </li>
              <li
                className={`Navbar-item ${
                  navMenu ? (navMenu.id == 4 ? "active" : "") : ""
                }`}
                onClick={() => mobNavHandler(4)}
              >
                <span className="links">
                  Resources <IoIosArrowDown />
                </span>
                <div className="mob-nav-content">
                  {!!navMenu && !!navMenu.subLinks && (
                    <>
                      {!!navMenu.subLinks[0] && (
                        <>
                          <section className="first-section">
                            <h2>{navMenu.subLinks[0].title}</h2>
                            <ul>
                              {navMenu.subLinks[0].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </>
                      )}
                      {!!navMenu.subLinks[1] && (
                        <div>
                          {sectiondivider()}
                          <section>
                            <h2>{navMenu.subLinks[1].title}</h2>
                            <ul>
                              {navMenu.subLinks[1].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </li>
              <li
                className={`Navbar-item ${
                  navMenu ? (navMenu.id == 5 ? "active" : "") : ""
                }`}
                onClick={() => mobNavHandler(5)}
              >
                <span className="links">
                  About <IoIosArrowDown />
                </span>
                <div className="mob-nav-content">
                  {!!navMenu && !!navMenu.subLinks && (
                    <>
                      {!!navMenu.subLinks[0] && (
                        <>
                          <section className="first-section">
                            <h2>{navMenu.subLinks[0].title}</h2>
                            <ul>
                              {navMenu.subLinks[0].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </>
                      )}
                      {!!navMenu.subLinks[1] && (
                        <div>
                          {sectiondivider()}
                          <section>
                            <h2>{navMenu.subLinks[1].title}</h2>
                            <ul>
                              {navMenu.subLinks[1].subTitle.map((link) => (
                                <li>
                                  <a href={link.link}>{link.name}</a>
                                </li>
                              ))}
                            </ul>
                          </section>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </li>
            </ul>
            <a href="/appointment" className="Navbar-appointments">
              Appointments
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

function sectiondivider() {
  return <div className="section-divider"></div>;
}

export default Navbar;
